import FindConversationResponseMessage from 'owa-service/lib/contract/FindConversationResponseMessage';
import getFocusedFilterForTable from 'mini-mail-list-store/lib/utils/getFocusedFilterForTable';
import getTableConversationRelation from 'mini-mail-list-store/lib/utils/getTableConversationRelation';
import getViewFilterForTable from 'mini-mail-list-store/lib/utils/getViewFilterForTable';
import MailFolderTableQuery from 'mini-mail-list-store/lib/store/schema/MailFolderTableQuery';
import TableView from 'mini-mail-list-store/lib/store/schema/TableView';
import { action } from 'satcheljs/lib/legacy';
import { ACTION_ON_LOAD_MORE_CONVERSATIONS_SUCCESS } from '../../utils/actionNames';
import { appendConversationWithSeekToConditionResponse } from 'mini-mail-list-response-processor';
import { findConversationWithSeekToCondition } from 'owa-mail-store/lib/services/findConversationWithSeekToCondition';
import { getRowSortByProperty } from '../../utils/tables/getRowSortByProperty';
import { LOAD_MORE_MAIL_ENDED } from 'mini-mail-workflow-tracking/lib/constants/ListViewWorkflowConstants';
import { LOAD_MORE_ROW_COUNT } from './TableLoadingConstants';
import { onLoadMoreRowsFailed } from './loadMoreInMailTable';
import { signalWorkflowEvent } from 'mini-workflow-manager';

export const onLoadMoreConversationsSucceeded = action(ACTION_ON_LOAD_MORE_CONVERSATIONS_SUCCESS)(
    function onLoadMoreConversationsSucceeded(
        tableView: TableView,
        responseMessage: FindConversationResponseMessage
    ): void {
        tableView.isLoading = false;
        tableView.hasErrorLoadingTable = false;
        appendConversationWithSeekToConditionResponse(
            tableView,
            responseMessage.Conversations,
            responseMessage.TotalConversationsInView
        );
        // Always update current loaded index to all items loaded since user triggered load more
        tableView.currentLoadedIndex = tableView.itemIds.length;
    }
);

export function loadMoreConversationsFromServer(tableView: TableView): Promise<void> {
    const lastItemIndex = tableView.itemIds.length - 1;
    const tableConversationRelation = getTableConversationRelation(
        tableView.itemIds[lastItemIndex],
        tableView.id
    );
    const mailTableQuery = tableView.tableQuery as MailFolderTableQuery;
    // We always perform seek to condition request when we are loading more.
    // We use instancekey of the last item we have in the loaded rows in the table.
    // The seekToCondition ask server to get items from this instanceKey the response of which will also
    // include the last item who instanceKey we used.
    return findConversationWithSeekToCondition(
        mailTableQuery.baseFolderId,
        tableConversationRelation.instanceKey,
        LOAD_MORE_ROW_COUNT,
        getViewFilterForTable(tableView), // VSO 13477: Directly pass tableQuery to table loading methods
        getRowSortByProperty(mailTableQuery),
        getFocusedFilterForTable(tableView),
        mailTableQuery.requestShapeName
    ).then(
        responseMessage => {
            onLoadMoreConversationsSucceeded(tableView, responseMessage);
        },
        error => {
            onLoadMoreRowsFailed(tableView);

            // Track load more failure as a perf datapoint
            return signalWorkflowEvent(
                LOAD_MORE_MAIL_ENDED,
                undefined,
                { isCore: true },
                {
                    error: new Error(
                        `Failed to load more email conversations: StackTrace=${error.stack}`
                    ),
                }
            );
        }
    );
}
